import { useState, useEffect } from 'react';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { DataSource } from 'components/DataSource';
import { ImageViewer } from 'components/ImageViewer';
import { Link } from 'react-router-dom';
import { ProgressBar } from 'primereact/progressbar';
import { Title } from 'components/Title';
import useAuth from 'hooks/useAuth';

import { useNavigate } from "react-router-dom";
export default function VendorPage() {
		const auth = useAuth();
	const [pageReady, setPageReady] = useState(true);
	const navigate = useNavigate();
  const [kyc, setKyc] = useState(null);
useEffect(() => {
  const loadKycStatus = async () => {
    try {
        const userId = auth.userId;   // <--- GET USER ID FROM AUTH
      const apiBase = process.env.REACT_APP_API_PATH;
      if (!apiBase) {
        console.error("❌ ENV not loaded! API cannot fire.");
        return;
      }
      const url = `${apiBase.replace(/\/$/, '')}/kyc/kyc-status?userId=${userId}`;
      console.log("Calling URL =", url);
      const response = await fetch(url);
      console.log("Response object:", response);
      if (!response.ok) {
        console.error("❌ API Error:", response.status);
        return;
      }
      const data = await response.json();
      console.log("KYC Data:", data);
      setKyc(data);
      if (!data.isKycCompleted) {
        navigate("/kyc", { replace: true });
      }
    } catch (err) {
      console.error("KYC API failed:", err);
    }
  };
  loadKycStatus();
}, [navigate]);
	return (
		<main id="VendorPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="Vendor"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    {/* Main content */}
                    <main className="flex-1 p-4 w-full max-w-5xl mx-auto">
                        <div className="">
                            <DataSource apiPath="components_data/vendor_data_repeater" showLoading={false}>
                                {({ response = [], loading, reload }) => (
                                <>
                                <div>
                                    <div className="flex justify-content-between gap-3">
                                        <div className="text-2xl">Today's Collection</div>
                                        <div className="p-3 text-center">
                                            <Button onClick={() => reload()} icon="pi pi-refresh" />
                                        </div>
                                    </div>
                                    {/* 🔹 Loading indicator */}
                                    {loading && (
                                    <div className="p-2">
                                        <ProgressBar mode="indeterminate" style={{ height: '6px' }} />
                                    </div>
                                    )}
                                    {/* 🔹 No data message */}
                                    {!loading && (!response || response.length === 0) && (
                                    <div className="p-3 text-center text-gray-500">No records found</div>
                                    )}
                                    {/* 🔹 Data list */}
                                    {!loading &&
                                    response &&
                                    response.length > 0 &&
                                    response.map((item, index) => (
                                    <Link key={index} to="#" className="p-3 gap-3 card flex mb-2">
                                        <Avatar
                                            icon="pi pi-angle-double-right"
                                            size="large"
                                            className="bg-primary text-white"
                                            />
                                            <div className="col-4 md:col-4">
                                                <div className="card flex gap-3 align-items-center card shadow-none p-3 surface-100 ">
                                                    <div className="">
                                                        <div className="text-400 font-medium mb-1">Photo</div>
                                                        <div className="font-bold"><ImageViewer imageSize="medium" previewSize="" src={item.photo} width="auto" height="auto" numDisplay={1} style={{maxWidth:'100%'}} /></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="font-bold">
                                                <Card
                                                title={item.customername}
                                                subTitle={`Loan No: ${item.loanaccountno}`}
                                                className="shadow-2"
                                                footer={
                                                <div className="flex justify-content-between align-items-center mt-3">
                                                    <span
                                                    className={`font-semibold ${
                                                    item.paid?.trim() === 'PAID'
                                                    ? 'text-green-600'
                                                    : 'text-red-500'
                                                    }`}
                                                    >
                                                    {item.paid}
                                                    </span>
                                                    <Button
                                                    label="View Details"
                                                    icon="pi pi-eye"
                                                    size="small"
                                                    onClick={() => navigate(`/loanamort/detail/${item.loanaccountno}`)}
                                                    />
                                                </div>
                                                }
                                                >
                                                <div className="p-2">
                                                    <p>
                                                    <strong>Period:</strong> {item.period}
                                                    </p>
                                                    <p>
                                                    <strong>Payment:</strong> ₹{item.payment?.toFixed(2) ?? 0}
                                                    </p>
                                                    <p>
                                                    <strong>Current Balance:</strong> ₹
                                                    {item.current_balance?.toFixed(2) ?? 0}
                                                    </p>
                                                </div>
                                                </Card>
                                            </div>
                                            </Link>
                                            ))}
                                        </div>
                                        </>
                                        )}
                                    </DataSource>
                                </div>
                            </main>
                            {/* Footer */}
                            <footer className="w-full">
                            {/* Mobile fixed footer */}
                            <div className="sm:hidden fixed left-0 right-0 bottom-0 z-5 border-top-1 surface-border p-3 flex justify-content-center">
                                <Link to={`/createmandate`}>
                                    <Button
                                    label="Add New Customer"
                                    icon="pi pi-check"
                                    className="  w-full bg-green-500 hover:bg-green-600 border-none"
                                    />
                                    </Link>
                                </div>
                                </footer>
                                <div className="sm:hidden h-6" aria-hidden="true" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
		</main>
	);
}
